import { Typography, styled } from '@mui/material'
import { EventIllustration } from '../EventIllustration'
import { EventHeaderFragment } from './EventHeader.generated'

type EventHeaderProps = EventHeaderFragment

const PaddedRoot = styled('div')(({ theme }) => ({
  paddingTop: '1rem',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up(710)]: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: '-85px',
  },
}))

export const SVGContainer = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: '400px',
  margin: '0 auto',
  [theme.breakpoints.up(710)]: {
    margin: 0,
    zIndex: 19,
    transform: 'translateY(88px)',
    [theme.breakpoints.up(930)]: {
      transform: 'translateY(56px)',
    },
  },
}))

const EventInformationContainer = styled('header')(({ theme }) => ({
  backgroundColor: 'white',
  [theme.breakpoints.up('md')]: {
    width: '750px',
  },
}))

const HeadingPrefix = styled('div')({
  fontWeight: 400,
  lineHeight: 1.5,
  fontSize: '1rem',
  marginBottom: '10px',
})

interface GetEnquiryTextArgs {
  audience: EventHeaderFragment['audience']
  eventType: EventHeaderFragment['collection']['label']
}

const getEnquiryText = ({
  eventType,
  audience,
}: GetEnquiryTextArgs): string => {
  const formattedType =
    eventType === 'Something else' ? 'event' : eventType.toLocaleLowerCase()
  if (eventType === 'Wedding') return `Your ${formattedType} enquiry`

  if (audience === 'professional') {
    if (
      eventType === 'Networking' ||
      eventType === 'Meeting/Workshop' ||
      eventType === 'Conference'
    ) {
      return `Your ${formattedType} enquiry`
    }

    if (eventType === 'Party') return `Your work ${formattedType} enquiry`

    return `Your professional ${formattedType} enquiry`
  }
  if (eventType === 'Private Dining') return `Your ${formattedType} enquiry`

  if (
    eventType === 'Presentation' ||
    eventType === 'Party' ||
    eventType === 'Something else'
  ) {
    return `Your private ${formattedType} enquiry`
  }

  return `Your personal ${formattedType} enquiry`
}

const EventHeading = ({
  title: eventTitle,
  collection,
  audience,
}: EventHeaderProps): JSX.Element => (
  <>
    <Typography
      variant='h1'
      fontSize='2rem'
      lineHeight={'1.1875'}
      fontWeight={600}
    >
      <HeadingPrefix>
        {getEnquiryText({ audience, eventType: collection.label })}
        <Typography variant='visuallyHidden'>:</Typography>
      </HeadingPrefix>
      {eventTitle}
    </Typography>
  </>
)

const EventHeader = (props: EventHeaderProps): JSX.Element => {
  return (
    <PaddedRoot>
      <SVGContainer>
        <EventIllustration eventType={props.collection.label} />
      </SVGContainer>
      <EventInformationContainer>
        <EventHeading {...props} />
      </EventInformationContainer>
    </PaddedRoot>
  )
}

export default EventHeader
